<template>
  <div class="droplayer icon filter-box file-list-b relative">
    <v-menu offset-y :close-on-content-click="false" v-model="filterShow">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" :class="filterCount > 0 ? 'sel' : ''">필터</v-btn>
      </template>
      <div class="dropdown-list cnt board">
        <div class="dropdown-list_header">
          <span>{{ $i18nUtil.trans("search.filter.001","{cnt}건 선택", {cnt: filterCount}) }}</span>
          <button type="button" class="btn-refresh" v-if="filterCount > 0" @click="filterClear">새로고침</button>
        </div>
        <div class="cnt_inner clear">
          <div class="cnt-option">
            <div class="tit">{{ $i18nUtil.trans("entity.file.filter.filepath","파일 경로") }}</div>
            <!-- <ul>
              <li>
                <input type="checkbox" name="" id="boardFileLocationBlock" value="BLOCK"
                  v-model="checkFileLocationsFilter" 
                ><label for="boardFileLocationBlock">보드 첨부파일</label>
              </li>
              <li>
                <input type="checkbox" name="" id="boardFileLocationDecision" value="DECISION"
                  v-model="checkFileLocationsFilter" 
                ><label for="boardFileLocationDecision">의사결정</label>
              </li>
              <li>
                <input type="checkbox" name="" id="boardFileLocationOutput" value="OUTPUT"
                  v-model="checkFileLocationsFilter" 
                ><label for="boardFileLocationOutput">최종결과물</label>
              </li>
            </ul> -->
            <ul>
              <li v-for="(item, idx) in fileLocations" :key="'boardFileLocation_'+idx">
                <input type="checkbox" name="" :id="'BoardFileLocations_'+idx" :value="item.location"
                  v-model="modelFileLocationCodeList"
                ><label :for="'BoardFileLocations_'+idx">{{item.locationName}}</label>
              </li>
            </ul>
          </div>
          <div class="cnt-file">
            <div class="tit">{{ $i18nUtil.trans("entity.file.filter.fileExt","파일 유형") }}</div>
            <ul>
              <!-- <li>
                <input type="checkbox" name="" id="boardFileExtAll"
                  v-model="isCheckFileExtAllFilter"
                ><label for="boardFileExtAll">전체</label>
              </li> -->
              <li v-for="(ext, index) in extList" :key="index">
                <input type="checkbox" :id="'boardFileExt' + index" :value="ext.value"
                  v-model="modelExtCodeList"
                ><label :for="'boardFileExt' + index">{{ ext.name }}</label>
              </li>
            </ul>
          </div>
          <!-- <div class="cnt-editor">
            <div class="tit">생성/수정자</div>
            <ul>
              <li>
                <input type="checkbox" name="" id="boardFileEditorAll"
                  v-model="isCheckFileEditorAllFilter"
                ><label for="boardFileEditorAll">전체</label>
              </li>
              <li v-for="(user, index) in userList" :key="index">
                <input type="checkbox" :id="'boardFileEditor' + index" :value="user"
                  v-model="checkFileEditorsFilter"
                ><label :for="'boardFileEditor' + index">{{ user }}</label>
              </li>
            </ul>
          </div> -->
        </div>
        <div class="dropdown-list_foot">
          <button type="button" class="btn-primary-small" @click="recoverFilter">{{ $i18nUtil.trans("button.filter.cancel","취소") }}</button>
          <button type="button" class="btn-primary-small black" @click="applyFilter">{{ $i18nUtil.trans("button.filter.apply","적용") }}</button>
        </div>
        <!-- <div class="info">필터는 중복 선택이 가능합니다.</div> -->
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: [
    "extList", // 파일 유형 목록
    "userList", // 생성/수정자 목록
    "initFilter"
  ],
  // props: {
  //   extList: Array, // 파일 유형 목록
  //   userList: Array, // 생성/수정자 목록
  //   checkCount: Number,
  //   checkFileLocations: Array,
  //   checkFileExts: Array,
  //   checkFileEditors: Array
  // },
  data() {
    return {
      // show: false, // 필터 영역 노출 여부
      // apply: false, // 필터 적용 여부
      // checkFilterCount: this.checkCount, // 체크한 필터 수
      // checkFileLocationsFilter: this.checkFileLocations, // 체크한 파일 경로 필터 목록
      // checkFileExtsFilter: this.checkFileExts, // 체크한 파일 유형 필터 목록
      // checkFileEditorsFilter: this.checkFileEditors // 체크한 생성/수정자 목록
      filterCount: 0,
      fileLocations: [
        {location: 'BLOCK', locationName: this.$i18nUtil.trans("entity.file.locationKbn.block","보드 첨부파일")}
        , {location: 'DECISION', locationName: this.$i18nUtil.trans("entity.file.locationKbn.decision","의사결정")}
        , {location: 'OUTPUT', locationName: this.$i18nUtil.trans("entity.file.locationKbn.output","최종결과물")}
      ],
      // 파일 경로 리스트
      prevModelFileLocationCodeList: [],
      modelFileLocationCodeList: [],
      //파일유형 리스트 
      prevModelExtCodeList: [],
      modelExtCodeList: [],
      filterShow: false,
      filterApply: false,
    };
  },
  watch: {
    // show: {
    //   handler() {
    //     let obj = this;
    //     if(!obj.show && !obj.apply) { // 필터 미적용 및 닫힘 시
    //       setTimeout(function() {
    //         obj.setPreviousFilter();
    //       }, 500);
    //     }

    //     if(!obj.show && obj.apply) { // 필터 적용 및 닫힘 시
    //       let param = {};
    //       param.checkFilterCount = obj.checkFilterCount;
    //       param.checkFileLocationsFilter = obj.checkFileLocationsFilter;
    //       param.checkFileExtsFilter = obj.checkFileExtsFilter;

    //       obj.apply = false;
    //       obj.$emit("applyFilter", param);
    //     }
    //   }
    // }
    filterShow: {
      handler() {
        let obj = this;
        setTimeout(()=> {
          if(!obj.filterShow && !obj.filterApply) {
            obj.modelFileLocationCodeList = obj.prevModelFileLocationCodeList;
            obj.modelExtCodeList = obj.prevModelExtCodeList;
          }
  
          if(obj.filterApply) {
            obj.filterApply = false;
          }
        }, 50);
      }
    },
    modelFileLocationCodeList: {
      handler() {
        this.filterCount = this.modelFileLocationCodeList.length + this.modelExtCodeList.length;
      }
    },
    modelExtCodeList: {
      handler() {
        this.filterCount = this.modelFileLocationCodeList.length + this.modelExtCodeList.length;
      }
    },
    filterReset: {
      handler() {
        let obj = this;
        if(this.$props.filterReset) {
          obj.prevModelFileLocationCodeList = [];
          obj.prevModelExtCodeList = [];
          obj.filterClear();
        }
      }
    },
    initFilter: {
      handler() {
        let obj = this;
        if(this.initFilter.checkFileLocations.length != 0){ /*  && this.initFilter.gradeCodeList.length != this.boardGradeList.length */
          obj.modelFileLocationCodeList = obj.initFilter.checkFileLocations;
          obj.prevModelFileLocationCodeList = obj.initFilter.checkFileLocations;
        }
        if(this.initFilter.checkFileExts.length != 0){ /*  && this.initFilter.statusList.length != this.boardStatusList.length */
          obj.modelExtCodeList = obj.initFilter.checkFileExts;
          obj.prevModelExtCodeList = obj.initFilter.checkFileExts;
        }
        obj.filterShow = false;
        obj.filterApply = true;
      }
    }
  },
  methods: {
    // /* 필터 적용 */
    // applyFilter() {
    //   let obj = this;
    //   obj.apply = true;
    //   obj.show = false;
    // },
    // /* 필터 닫기 */
    // closeFilter() {
    //   let obj = this;
    //   obj.apply = false;
    //   obj.show = false;
    // },
    // /* 필터 체크 */
    // checkFilter() {
    //   let obj = this;
    //   let checkFileLocationsCount = obj.checkFileLocationsFilter.length;
    //   let checkFileExtsCount = obj.checkFileExtsFilter.length;
    //   let checkFilterCount = checkFileLocationsCount + checkFileExtsCount;
      
    //   obj.checkFilterCount = checkFilterCount;
    // },
    // /* 필터 초기화 */
    // resetFilter() {
    //   let obj = this;
    //   obj.checkFileLocationsFilter = [];
    //   obj.checkFileExtsFilter = [];
    //   obj.checkFilterCount = 0;
    // },
    // /* 이전 필터 선택 값 적용 */
    // setPreviousFilter() {
    //   let obj = this;
    //   obj.checkFileLocationsFilter = obj.checkFileLocations;
    //   obj.checkFileExtsFilter = obj.checkFileExts;
    //   obj.checkFilterCount = obj.checkCount;
    // },
    // 필터 새로고침
    filterClear() {
      let obj = this;
      obj.modelFileLocationCodeList = [];
      obj.modelExtCodeList = [];
    },
    // 필터 취소
    recoverFilter() {
      let obj = this;
      // 필터 되돌림
      obj.modelFileLocationCodeList = obj.prevModelFileLocationCodeList;
      obj.modelExtCodeList = obj.prevModelExtCodeList;
      obj.filterShow = false;
      obj.filterApply = false;
    },
    // 필터 적용
    applyFilter() {
      let obj = this;
      // 필터 변경
      obj.prevModelFileLocationCodeList = obj.modelFileLocationCodeList;
      obj.prevModelExtCodeList = obj.modelExtCodeList;

      obj.filterShow = false;
      obj.filterApply = true;
      let rtnFileLocationCodeList = obj.modelFileLocationCodeList.length == 0 ? [] : obj.modelFileLocationCodeList;
      let rtnExtCodeList = obj.modelExtCodeList.length == 0 ? [] : obj.modelExtCodeList;
      
      let locationCheckYn = true;
      let extCheckYn = true;

      if(obj.modelFileLocationCodeList.length == 0) {
        locationCheckYn = false;
        obj.fileLocations.forEach((elem)=> {
          rtnFileLocationCodeList.push(elem.location);
        });
      }
      if(obj.modelExtCodeList.length == 0) {
        extCheckYn = false;
        obj.extList.forEach((elem)=> {
          rtnExtCodeList.push(elem.value);
        });
      }
      obj.$emit('applyFilter', {
                                checkFileLocationsFilter: rtnFileLocationCodeList, 
                                checkFileExtsFilter: rtnExtCodeList,
                                locationCheckYn: locationCheckYn,
                                extCheckYn: extCheckYn});
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/filter/BoardFileFilterBox.vue